import React from 'react';
import styles from './ThumbList.module.scss';

export class ThumbList extends React.Component<{items:any[]}>
{
	render()
	{
		return (
			<div className={styles.container}>
				{
					this.props.items?.sort((a, b)=>(a['order'] < b['order']?-1:a['order']>b['order']?1:0)).map((item, i) => {
						return (<ThumbItem {...item} />);
					})
				}
			</div>
		);
	}
}

class ThumbItem extends React.Component<{thumb:string, entry:number, order:number, title:string, description:string}>
{
	render()
	{
		let order = this.props.order.toString();
		order = order.padStart(2, '0');
		return (<div className={styles.item}>
			<img src={this.props.thumb} />
			<div className={styles.entry}>Entry No.{order}</div>
			<div className={styles.title}>{this.props.title}</div>
			<div className={styles.description}>{this.props.description}</div>
		</div>)
	}
}